function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "0 0 16 15"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: "2.17529",
                y1: "1.58649",
                x2: "8.46417",
                y2: "1.58649",
                stroke: "#718096",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "2.17529",
                y1: "13.8087",
                x2: "8.46417",
                y2: "13.8087",
                stroke: "#718096",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "1.56543",
                y1: "14.8088",
                x2: "1.56543",
                y2: "0.573311",
                stroke: "#718096",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.7127 8.03123C15.908 7.83596 15.908 7.51938 15.7127 7.32412L12.5307 4.14214C12.3355 3.94688 12.0189 3.94688 11.8236 4.14214C11.6284 4.3374 11.6284 4.65398 11.8236 4.84925L14.6521 7.67767L11.8236 10.5061C11.6284 10.7014 11.6284 11.0179 11.8236 11.2132C12.0189 11.4085 12.3355 11.4085 12.5307 11.2132L15.7127 8.03123ZM5.96875 8.17767H15.3592V7.17767H5.96875V8.17767Z",
                fill: "#718096"
            })
        ]
    }));
};
export default Icon;
